var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "react-bootstrap";

// eslint-disable-next-line react/prop-types
export default function CheckboxWrapper(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return React.createElement(
    Checkbox,
    _extends({ className: className + " uit-custom-control-wrapper" }, props),
    React.createElement("span", { className: "uit-custom-control" }),
    children
  );
}

CheckboxWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string
} : {};